import script from "./btn-table.vue?vue&type=script&setup=true&lang=js"
export * from "./btn-table.vue?vue&type=script&setup=true&lang=js"

import "./btn-table.vue?vue&type=style&index=0&id=10adbd55&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10adbd55"]])

export default __exports__